import { defineComponent as _defineComponent } from 'vue'
import { getDealWithList, getListAdd, getProcessingContact } from '@/api/miscellaneous';

import { ref } from 'vue';

import moment from 'moment';
import userStoreModule from '@/store/modules/user';
import { listSubscribe } from '@/hooks';
import { useRoute, useRouter } from 'vue-router';

import RestrictDialog from '@/components/RestrictDialog.vue';
import ListItemAd from '@/components/ListItemAd.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProcessingList',
  setup(__props, { expose }) {
  expose();

const { subscribe, isSubscribe } = listSubscribe();
const list = ref<any[]>([]);
const addList = ref<any[]>([]);
const getListData = ref({
    page: 1,
    size: 20,
    keyword: '',
});
const loading = ref(false);
const finished = ref(false);

const restrictShow = ref(false);
const isShowTel = ref(false);
const restrictCode = ref('');
const tel = ref('');

const getList = () => {
    getDealWithList(getListData.value).then(res => {
        list.value = [...list.value, ...res.items];
        loading.value = false;
        getListData.value.page += 1;
        finished.value = getListData.value.page * getListData.value.size >= res.total;
    });
};

const search = () => {
    getListData.value.page = 1;
    list.value = [];
    getList();
};
const getTell = (id: string): void => {
    getProcessingContact({ id })
        .then(res => {
            tel.value = res;
            isShowTel.value = true;
        })
        .catch(e => {
            let { code } = e;
            if ([120].includes(code)) {
                restrictCode.value = code;
                restrictShow.value = true;
            }
        });
};
const getAdd = () => {
    getListAdd({ keywords: '广告位用勿动处理求购供应列表中' }).then((res: any) => {
        addList.value = JSON.parse(res.contentJson);
        getList();
    });
};
getAdd();
// getList();

const __returned__ = { subscribe, isSubscribe, list, addList, getListData, loading, finished, restrictShow, isShowTel, restrictCode, tel, getList, search, getTell, getAdd, getDealWithList, getListAdd, getProcessingContact, ref, moment, userStoreModule, listSubscribe, useRoute, useRouter, RestrictDialog, ListItemAd }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})